<template>
  <div class="relative" ref="dropdownRef">
    <button
      @click="open = !open"
      class="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200
             rounded-lg shadow-sm text-sm font-medium hover:bg-slate-100
             focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      🌐 {{ currentLabel }}
    </button>

    <!-- Option List -->
    <div
      v-if="open"
      class="absolute right-0 mt-2 w-40 bg-white border border-slate-200
             rounded-lg shadow-lg overflow-hidden z-50"
    >
      <button
        v-for="opt in options"
        :key="opt.value"
        @click="select(opt.value)"
        class="w-full px-4 py-2 text-left text-sm hover:bg-slate-100
               flex items-center justify-between"
      >
        <span>{{ opt.label }}</span>
        <span v-if="locale === opt.value">✓</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { STORAGE_KEYS } from '@/config/storageKeys'

type LangOption = {
  value: string
  label: string
}

const props = defineProps<{
  options?: LangOption[]
}>()

const { locale } = useI18n()

const open = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)

const defaultOptions: LangOption[] = [
  { value: 'en', label: 'Eng' },
  { value: 'zh-TW', label: '繁' },
  { value: 'zh-CN', label: '簡' },
  { value: 'ja-JP', label: '日' }
]

const options = computed(() => props.options ?? defaultOptions)

const currentLabel = computed(() =>
  options.value.find(o => o.value === locale.value)?.label ?? 'Language'
)

const select = (lang: string) => {
  locale.value = lang
  localStorage.setItem(STORAGE_KEYS.LANGUAGE, lang)
  open.value = false
}

// Close on outside click
const onClickOutside = (e: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target as Node)) {
    open.value = false
  }
}

onMounted(() => document.addEventListener('click', onClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside))
</script>
